import styled, { css } from 'styled-components';
import flash from '~/assets/icons/flash.svg';
import hand from '~/assets/icons/hand.svg';

const StyledIcon = styled.div<{ $type: 'normal' | 'help' | 'error' }>`
	width: 14px;
	height: 14px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 14px 14px;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 14px 14px;
	${(props) =>
		props.$type &&
		css`
			mask-image: url(${props.$type === 'normal' ? hand : flash});
			-webkit-mask-image: url(${props.$type === 'normal' ? hand : flash});
		`}
	background-color: ${(props) =>
		props.$type === 'normal' || props.$type === 'error'
			? '#ffffff'
			: '#FFD900'};
	transition: background-color 0.3s ease;
	cursor: pointer;
`;

const StyledContainer = styled.div<{
	$type: 'normal' | 'help' | 'error';
	$active?: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 30px;
	background-color: ${(props) =>
		props.$type === 'normal'
			? 'rgba(255, 255, 255, 0.1)'
			: props.$type === 'help'
			? 'rgba(255, 217, 0, 0.1)'
			: '#D50004'};
	border: 1px solid
		${(props) =>
			props.$type === 'normal'
				? 'rgba(255, 255, 255, 0.1)'
				: props.$type === 'help'
				? 'rgba(255, 217, 0, 0.5)'
				: '#D50004'};
	transition:
		background-color 0.3s ease,
		border 0.3s ease,
		opacity 0.3s ease;

	${({ $type }) =>
		$type !== 'error' &&
		css`
			&:hover {
				background-color: ${$type === 'normal' ? '#ffffff' : '#FFD900'};

				${StyledIcon} {
					background-color: #000000;
				}
			}
		`}

	${({ $active, $type }) =>
		$active &&
		css`
			background-color: ${$type === 'normal' ? '#ffffff' : '#FFD900'};

			${StyledIcon} {
				background-color: #000000;
			}
		`}
`;

export { StyledContainer, StyledIcon };
